<template>
  <div class="footer">
    <p class="footer-text">
      {{ "© " + fullYear + " BiletDV.ru - Все права защищены." }}
    </p>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "FooterItem",
  data() {
    return {
      fullYear: this.getFullYear(),
    };
  },
  methods: {
    getFullYear() {
      const date = new Date();
      const year = date.getFullYear();
      return year;
    },
  },
});
</script>

<style>
@media screen and (max-width: 767px) {
  .footer {
    vertical-align: bottom;
    margin-top: 60px;
    width: 100%;
    background-color: #2e373f;
    min-height: 64px;
    text-align: center;
  }

  .footer-text {
    font-style: normal;
    font-weight: bold;
    font-size: 9px;
    line-height: 11px;
    color: #ffffff;
    line-height: 64px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .footer {
    margin-top: 60px;
    width: 100%;
    background-color: #2e373f;
    min-height: 64px;
    text-align: center;
  }

  .footer-text {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    color: #ffffff;
    line-height: 64px;
  }
}

@media screen and (min-width: 1025px) {
  .footer {
    margin-top: 60px;
    width: 100%;
    background-color: #2e373f;
    min-height: 64px;
    text-align: center;
  }

  .footer-text {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    line-height: 64px;
  }
}
</style>
